/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ImportacaoFontesNaoSeladasAutorizacaoFormDto } from '../models/importacao-fontes-nao-seladas-autorizacao-form-dto';
import { ImportacaoFontesNaoSeladasCriteriaDto } from '../models/importacao-fontes-nao-seladas-criteria-dto';
import { ImportacaoFontesNaoSeladasDto } from '../models/importacao-fontes-nao-seladas-dto';
import { ImportacaoFontesNaoSeladasFormDto } from '../models/importacao-fontes-nao-seladas-form-dto';
import { ImportacaoFontesNaoSeladasPageDto } from '../models/importacao-fontes-nao-seladas-page-dto';
import { ImportacaoFontesNaoSeladasTotalAutorizadoLicencaDto } from '../models/importacao-fontes-nao-seladas-total-autorizado-licenca-dto';
import { ImportacaoFontesNaoSeladasTotalAutorizadoTitularDto } from '../models/importacao-fontes-nao-seladas-total-autorizado-titular-dto';


/**
 * Importação de Fontes Não Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class ImportacaoFontesNaoSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getImportacoesFns
   */
  static readonly GetImportacoesFnsPath = '/importacao-fontes-nao-seladas';

  /**
   * Pesquisar Importações Fontes Não Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImportacoesFns()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImportacoesFns$Response(params?: {
    criteria?: ImportacaoFontesNaoSeladasCriteriaDto;
  }): Observable<StrictHttpResponse<ImportacaoFontesNaoSeladasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesNaoSeladasService.GetImportacoesFnsPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesNaoSeladasPageDto>;
      })
    );
  }

  /**
   * Pesquisar Importações Fontes Não Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getImportacoesFns$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImportacoesFns(params?: {
    criteria?: ImportacaoFontesNaoSeladasCriteriaDto;
  }): Observable<ImportacaoFontesNaoSeladasPageDto> {

    return this.getImportacoesFns$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesNaoSeladasPageDto>) => r.body as ImportacaoFontesNaoSeladasPageDto)
    );
  }

  /**
   * Path part for operation submeterImpFns
   */
  static readonly SubmeterImpFnsPath = '/importacao-fontes-nao-seladas';

  /**
   * Submeter Importacao de Fontes Nao Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterImpFns()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submeterImpFns$Response(params?: {
    body?: ImportacaoFontesNaoSeladasFormDto
  }): Observable<StrictHttpResponse<ImportacaoFontesNaoSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesNaoSeladasService.SubmeterImpFnsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesNaoSeladasDto>;
      })
    );
  }

  /**
   * Submeter Importacao de Fontes Nao Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterImpFns$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submeterImpFns(params?: {
    body?: ImportacaoFontesNaoSeladasFormDto
  }): Observable<ImportacaoFontesNaoSeladasDto> {

    return this.submeterImpFns$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesNaoSeladasDto>) => r.body as ImportacaoFontesNaoSeladasDto)
    );
  }

  /**
   * Path part for operation getPedidoImpFns
   */
  static readonly GetPedidoImpFnsPath = '/importacao-fontes-nao-seladas/{id}';

  /**
   * Pesquisar Importacao Fontes Não Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPedidoImpFns()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidoImpFns$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ImportacaoFontesNaoSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesNaoSeladasService.GetPedidoImpFnsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesNaoSeladasDto>;
      })
    );
  }

  /**
   * Pesquisar Importacao Fontes Não Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPedidoImpFns$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidoImpFns(params: {
    id: number;
  }): Observable<ImportacaoFontesNaoSeladasDto> {

    return this.getPedidoImpFns$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesNaoSeladasDto>) => r.body as ImportacaoFontesNaoSeladasDto)
    );
  }

  /**
   * Path part for operation updateImpFns
   */
  static readonly UpdateImpFnsPath = '/importacao-fontes-nao-seladas/{id}';

  /**
   * Editar Pedido Importacao Fontes Nao Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateImpFns()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateImpFns$Response(params: {
    id: number;
    body?: ImportacaoFontesNaoSeladasFormDto
  }): Observable<StrictHttpResponse<ImportacaoFontesNaoSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesNaoSeladasService.UpdateImpFnsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesNaoSeladasDto>;
      })
    );
  }

  /**
   * Editar Pedido Importacao Fontes Nao Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateImpFns$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateImpFns(params: {
    id: number;
    body?: ImportacaoFontesNaoSeladasFormDto
  }): Observable<ImportacaoFontesNaoSeladasDto> {

    return this.updateImpFns$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesNaoSeladasDto>) => r.body as ImportacaoFontesNaoSeladasDto)
    );
  }

  /**
   * Path part for operation updateAutorizacaoImpFns
   */
  static readonly UpdateAutorizacaoImpFnsPath = '/importacao-fontes-nao-seladas/{id}/autorizacao';

  /**
   * Preencher autorização de um pedido de fontes não seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutorizacaoImpFns()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoImpFns$Response(params: {
    id: number;
    body?: ImportacaoFontesNaoSeladasAutorizacaoFormDto
  }): Observable<StrictHttpResponse<ImportacaoFontesNaoSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesNaoSeladasService.UpdateAutorizacaoImpFnsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesNaoSeladasDto>;
      })
    );
  }

  /**
   * Preencher autorização de um pedido de fontes não seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAutorizacaoImpFns$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoImpFns(params: {
    id: number;
    body?: ImportacaoFontesNaoSeladasAutorizacaoFormDto
  }): Observable<ImportacaoFontesNaoSeladasDto> {

    return this.updateAutorizacaoImpFns$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesNaoSeladasDto>) => r.body as ImportacaoFontesNaoSeladasDto)
    );
  }

  /**
   * Path part for operation previewDocAutorizacaoImportacaoFns
   */
  static readonly PreviewDocAutorizacaoImportacaoFnsPath = '/importacao-fontes-nao-seladas/{id}/preview-doc-autorizacao';

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewDocAutorizacaoImportacaoFns()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoImportacaoFns$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesNaoSeladasService.PreviewDocAutorizacaoImportacaoFnsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewDocAutorizacaoImportacaoFns$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoImportacaoFns(params: {
    id: number;
  }): Observable<Blob> {

    return this.previewDocAutorizacaoImportacaoFns$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation getTotalAutorizadoLicenca
   */
  static readonly GetTotalAutorizadoLicencaPath = '/importacao-fontes-nao-seladas/total-licenca/{codLicenca}/{codIsotopo}/{ano}';

  /**
   * Total autorizado por licenca - titular.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTotalAutorizadoLicenca()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalAutorizadoLicenca$Response(params: {
    codLicenca: string;
    codIsotopo: string;
    ano: number;
  }): Observable<StrictHttpResponse<ImportacaoFontesNaoSeladasTotalAutorizadoLicencaDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesNaoSeladasService.GetTotalAutorizadoLicencaPath, 'get');
    if (params) {
      rb.path('codLicenca', params.codLicenca, {});
      rb.path('codIsotopo', params.codIsotopo, {});
      rb.path('ano', params.ano, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesNaoSeladasTotalAutorizadoLicencaDto>;
      })
    );
  }

  /**
   * Total autorizado por licenca - titular.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTotalAutorizadoLicenca$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalAutorizadoLicenca(params: {
    codLicenca: string;
    codIsotopo: string;
    ano: number;
  }): Observable<ImportacaoFontesNaoSeladasTotalAutorizadoLicencaDto> {

    return this.getTotalAutorizadoLicenca$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesNaoSeladasTotalAutorizadoLicencaDto>) => r.body as ImportacaoFontesNaoSeladasTotalAutorizadoLicencaDto)
    );
  }

  /**
   * Path part for operation getTotalAutorizadoTitular
   */
  static readonly GetTotalAutorizadoTitularPath = '/importacao-fontes-nao-seladas/total-titular/{codTitular}/{codIsotopo}/{ano}';

  /**
   * Total autorizado por licenca - titular.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTotalAutorizadoTitular()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalAutorizadoTitular$Response(params: {
    codTitular: string;
    codIsotopo: string;
    ano: number;
  }): Observable<StrictHttpResponse<ImportacaoFontesNaoSeladasTotalAutorizadoTitularDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesNaoSeladasService.GetTotalAutorizadoTitularPath, 'get');
    if (params) {
      rb.path('codTitular', params.codTitular, {});
      rb.path('codIsotopo', params.codIsotopo, {});
      rb.path('ano', params.ano, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesNaoSeladasTotalAutorizadoTitularDto>;
      })
    );
  }

  /**
   * Total autorizado por licenca - titular.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTotalAutorizadoTitular$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalAutorizadoTitular(params: {
    codTitular: string;
    codIsotopo: string;
    ano: number;
  }): Observable<ImportacaoFontesNaoSeladasTotalAutorizadoTitularDto> {

    return this.getTotalAutorizadoTitular$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesNaoSeladasTotalAutorizadoTitularDto>) => r.body as ImportacaoFontesNaoSeladasTotalAutorizadoTitularDto)
    );
  }

}
